export class TeasersCols {
    constructor() {
        this.title   = "TeasersCols";
        this.config  = null;
        this.cache   = {};

        this.threecol   = "col-md-6 col-lg-4";
        this.twocol     = "col-md-6";
        this.bgwhite    = "bg-white";

        this.body       = jQuery("body");
        this.teaser     = jQuery(".ce.info-teasers .teaser");

        this.checkPage();
    };


    checkPage() {
        if ((!this.body.hasClass("full_content_menu") && this.body.hasClass("full_ce"))) {
            console.info('Max. 3 Spalten anzeigen');
            this.teaser.addClass(this.threecol);
        } else {
            console.info('Max. 2 Spalten anzeigen');
            this.teaser.addClass(this.twocol);
        }
        if (this.body.hasClass("teaser_white")) {
            console.info('Hintergrund weiß');
            this.teaser.addClass(this.bgwhite);
        }
    };
};
